import script from "./SMA.vue?vue&type=script&lang=js"
export * from "./SMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__